module.exports = __webpack_public_path__ + "img/selected0-min.b83051f9.png";